import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
const tablePrefix = 'table';
const detailPrefix = 'table.detail';
const teacherFilterPrefix = 'teacherFilter';
const teacherInfoPrefix = 'teacherInfo';
const dateFilterOptionsPrefix = 'dateFilterOptions';
const infoAndErrorPrefix = 'infoAndError';
const reportPrefix = 'report';

export function useTexts() {
  const { t } = useTranslation(
    TranslationsKeys.TEACHER_MANAGMENT_TEACHER_ATTENDANCES,
  );
  return {
    viewInfo: t('viewInfo'),
    table: {
      responsible: t(`${tablePrefix}.responsible`),
      faculty: t(`${tablePrefix}.faculty`),
      course: t(`${tablePrefix}.course`),
      section: t(`${tablePrefix}.section`),
      date: t(`${tablePrefix}.date`),
      initialModule: t(`${tablePrefix}.initialModule`),
      endModule: t(`${tablePrefix}.endModule`),
      classState: t(`${tablePrefix}.classState`),
      justification: t(`${tablePrefix}.justification`),
      justificationStatus: t(`${tablePrefix}.justificationStatus`),
      viewMore: t(`${tablePrefix}.viewMore`),
      noData: t(`${tablePrefix}.noData`),
      detail: {
        justificationStatusOptions: {
          pendingLabel: t(
            `${detailPrefix}.justificationStatusOptions.pendingLabel`,
          ),
          approvedLabel: t(
            `${detailPrefix}.justificationStatusOptions.approvedLabel`,
          ),
          deniedLabel: t(
            `${detailPrefix}.justificationStatusOptions.deniedLabel`,
          ),
        },
        observationLabel: t(`${detailPrefix}.observationLabel`),
        justificationLabel: t(`${detailPrefix}.justificationLabel`),
        justificationStatus: t(`${detailPrefix}.justificationStatus`),
        noDateRegistered: t(`${detailPrefix}.noDateRegistered`),
        saveButton: t(`${detailPrefix}.saveButton`),
        uploadFIlesLabel: t(`${detailPrefix}.uploadFIlesLabel`),
        successToastLabel: t(`${detailPrefix}.successToastLabel`),
        failedToastLabel: t(`${detailPrefix}.failedToastLabel`),
      },
    },
    teacherFilter: {
      idTypeLabel: t(`${teacherFilterPrefix}.idTypeLabel`),
      identificationLabel: t(`${teacherFilterPrefix}.identificationLabel`),
      searchButton: t(`${teacherFilterPrefix}.searchButton`),
      clearButton: t(`${teacherFilterPrefix}.clearButton`),
    },
    teacherInfo: {
      teacherLabel: t(`${teacherInfoPrefix}.teacherLabel`),
      idLabel: t(`${teacherInfoPrefix}.idLabel`),
    },
    dateFilterOptions: {
      filterLabel: t(`${dateFilterOptionsPrefix}.filterLabel`),
      lastMonth: t(`${dateFilterOptionsPrefix}.lastMonth`),
      last3Months: t(`${dateFilterOptionsPrefix}.last3Months`),
      last6Months: t(`${dateFilterOptionsPrefix}.last6Months`),
      lastYear: t(`${dateFilterOptionsPrefix}.lastYear`),
    },
    infoAndError: {
      searchUserInfo: {
        title: t(`${infoAndErrorPrefix}.searchUserInfo.title`),
        body: t(`${infoAndErrorPrefix}.searchUserInfo.body`),
      },
      userNotFoundError: {
        title: t(`${infoAndErrorPrefix}.userNotFoundError.title`),
        body: t(`${infoAndErrorPrefix}.userNotFoundError.body`),
      },
      noIrregularitiesInfo: {
        title: t(`${infoAndErrorPrefix}.noIrregularitiesInfo.title`),
        body: t(`${infoAndErrorPrefix}.noIrregularitiesInfo.body`),
      },
    },
    report: {
      btnDownload: t(`${reportPrefix}.btnDownload`),
      success: t(`${reportPrefix}.success`),
      error: t(`${reportPrefix}.error`),
    },
  };
}
